import React, { useState } from 'react';

import strings from './strings.json'

//* Styles
import styles from './Header.module.scss';
import useResponsiveJSX from 'hooks/useResponsiveJSX';

const MAIN_URL = 'https://filotrack.com';




const Header = () => {

    const LANG = document.documentElement.lang.substring(0, 2)
    const STRINGS_LANG = strings.hasOwnProperty(LANG) ? strings[LANG] : strings["en"]
    const PATH_LANG = LANG === "en" ? "" : `/${LANG}`
    const HOMEPAGE_URL = `${MAIN_URL}${PATH_LANG}/`;
    const CART_URL = `${MAIN_URL}${PATH_LANG}/cart`;


    const TABS = {
        "how_it_works": STRINGS_LANG.how_it_works,
        "corporate_gifts": STRINGS_LANG.corporate_gifts,
    };

    const PRODUCT_PAGE_BTN = STRINGS_LANG.buy_filo_tag

    function goToHomePage() {
        window.location.href = `${MAIN_URL}${HOMEPAGE_URL}`
    }

    function goToTab(tab){

        const LANG = document.documentElement.lang.substring(0, 2)
        const PAGE_LANG = LANG === "en" ? "/" : `/${LANG}`
        window.location.href = `${MAIN_URL}${PAGE_LANG}${tab.link}`
    }

    function goToCart(){
        window.location.href = `${MAIN_URL}${CART_URL}`
    }

    function goToProduct(){
        window.location.href = `${MAIN_URL}${PRODUCT_PAGE_BTN.link}`
    }

    const [ { isNavMenuOpen }, setIsNavMenuOpen ] = useState({ isNavMenuOpen: false })

    function triggerNavMenu(){

        setIsNavMenuOpen({ isNavMenuOpen: !isNavMenuOpen })

    }

    const bp = useResponsiveJSX()

    if(bp < 1){
        return(
            <nav className={`${styles['main-header']} ${isNavMenuOpen ? styles["nav-open"] : styles["nav-close"]}`}>
                <div className={styles["header-container"]}>
                    <div className={styles["logo-container"]}
                        onClick={() => goToHomePage()}
                    >
                        <img src="https://filotrack.com/wp-content/uploads/Logo_Filo_Red.png" alt="filo-logo" />
                    </div>
                    <div className={styles["mobile-menu-container"]}>
                        <div className={styles["menu-icon-container"]}
                            onClick={() => triggerNavMenu()}
                        >
                            <ion-icon name="menu-outline"></ion-icon>
                        </div>
                    </div>
                    <div className={styles["mobile-cart-container"]}>
                        <div className={styles["cart-icon-container"]}
                            onClick={() => goToCart()}
                        >
                            <ion-icon name="cart"></ion-icon>
                        </div>
                    </div>
                </div>
                <div className={`${styles["mobile-tabs-container"]} ${isNavMenuOpen ? styles["open"] : styles["close"]}`}>
                    {
                        Object.entries(TABS).map(([tabKey, tabInfo]) => {

                            return(
                                <div className={styles["mobile-nav-tab"]}
                                    key={`nav-tab-${tabKey}-${LANG}`}
                                    onClick={() => goToTab(tabInfo)}
                                >
                                    <p className={styles["tab-label"]}>{tabInfo.label}</p>
                                </div>
                            )

                        })
                    }
                    <div className={`${styles["btn"]} ${styles["filo-primary"]} ${styles["mobile-nav-tab"]}`}
                        onClick={() => goToProduct()}
                    >
                        {
                            PRODUCT_PAGE_BTN.label
                        }
                    </div>
                </div>
            </nav>
        )
    }

  return (
    <nav className={`${styles['main-header']} ${isNavMenuOpen ? styles["nav-open"] : styles["nav-close"]}`}>
        <div className={styles["header-container"]}>
            <div className={styles["logo-container"]}
                onClick={() => goToHomePage()}
            >
                <img src="https://filotrack.com/wp-content/uploads/Logo_Filo_Red.png" alt="filo-logo" />
            </div>
            <div className={styles["menu-container"]}>
                <div className={styles["tabs-container"]}>
                    {
                        Object.entries(TABS).map(([tabKey, tabInfo]) => {

                            return(
                                <div className={styles["nav-tab"]}
                                    key={`nav-tab-${tabKey}-${LANG}`}
                                    onClick={() => goToTab(tabInfo)}
                                >
                                    <p className={styles["tab-label"]}>{tabInfo.label}</p>
                                </div>
                            )

                        })
                    }
                    <div className={`${styles["btn"]} ${styles["filo-primary"]}`}
                        onClick={() => goToProduct()}
                    >
                        {
                            PRODUCT_PAGE_BTN.label
                        }
                    </div>
                </div>
                <div className={styles["cart-container"]}>
                    <div className={styles["cart-icon-container"]}
                        onClick={() => goToCart()}
                    >
                        <ion-icon name="cart"></ion-icon>
                    </div>
                </div>
            </div>
            <div className={styles["mobile-menu-container"]}>
                <div className={styles["menu-icon-container"]}
                    onClick={() => triggerNavMenu()}
                >
                    <ion-icon name="menu-outline"></ion-icon>
                </div>
            </div>
            <div className={styles["mobile-cart-container"]}>
                <div className={styles["cart-icon-container"]}
                    onClick={() => goToCart()}
                >
                    <ion-icon name="cart"></ion-icon>
                </div>
            </div>
        </div>
        <div className={`${styles["mobile-tabs-container"]} ${isNavMenuOpen ? styles["open"] : styles["close"]}`}>
            {
                Object.entries(TABS).map(([tabKey, tabInfo]) => {

                    return(
                        <div className={styles["mobile-nav-tab"]}
                            key={`nav-tab-${tabKey}-${LANG}`}
                            onClick={() => goToTab(tabInfo)}
                        >
                            <p className={styles["tab-label"]}>{tabInfo.label}</p>
                        </div>
                    )

                })
            }
            <div className={`${styles["btn"]} ${styles["filo-primary"]} ${styles["mobile-nav-tab"]}`}
                onClick={() => goToProduct()}
            >
                {
                    PRODUCT_PAGE_BTN.label
                }
            </div>
        </div>
    </nav>
  )
}

export default Header